import React from "react"
import "./ErrorPage.css"
function ErrorPage() {
  return (
    <div className="centre-grid">
      <div className="error">
        Error 404:<p>Page not Found</p>{" "}
      </div>
    </div>
  )
}

export default ErrorPage
